import { useEffect, useState } from 'react';
import { Dimensions } from 'react-native';

const windowDimensions = Dimensions.get('window');

export const useScreenSize = () => {
  const [dimensions, setDimensions] = useState({
    height: windowDimensions.height,
    width: windowDimensions.width,
  });

  useEffect(() => {
    const subscription = Dimensions.addEventListener('change', ({ window }) => {
      setDimensions({ height: window.height, width: window.width });
    });
    return () => subscription?.remove();
  }, []);

  return dimensions;
};
